import vm from "@/main.js";
import { ajax } from "@/plugins/axios";

export const url = {
  getSysinfo: "/sys/info", //系统信息

  getCaptcha: "/captcha", //获取验证码
  getPhoneverification: "/phoneverification", //获取验证码
  getPhoneverification2: "/phoneverification2", //注销账号时获取验证码
  login: "/login", //用户登录
  logout: "/logout", //退出登录

  addinfo: "/user/addinfo", //注册账号
  getUserInfo: "/user/info", //获取用户信息
  changeInfo: "/user/changeinfo", //修改用户信息
  changepwdex: "/user/changepwdex", //重置密码
  changepwd: "/user/changepwd", //修改登陆密码
  delAccount: "/user/deleteinfo", //注销账号
  getMap: "/user/map", //获取地图
  setMap: "/user/setmap", //修改地图配置
  getUserLog: "/user/log", //查询用户日志
  userLogExport: "/user/log/export", //用户日志导出

  getUserDevInfo: "/userdev/info", //获取用户设备信息
  userDevShare: "/userdev/share", //设备分享
  userDevShare2: "/userdev/share2", //请求设备分享
  userDevUnShare: "/userdev/unshare", //设备取消分享
  getUserDevShareInfo: "/userdev/info2", //获取设备分享于用户信息
  getUserDevMsginfo: "/userdev/msginfo", //获取用户设备消息
  getUserDevState: "/userdev/state", //获取用户设备状态
  addUserDevInfo: "/userdev/addinfo", //注册用户设备
  shareUserdevAccept: "/userdev/accept", //接受或拒绝用户设备消息
  shareUserdevAccept2: "/userdev/accept2", //接受或拒绝请求用户设备消息
  shareUserdevComplete: "/userdev/complete", //确认用户设备消息(type=2)
  shareUserdevComplete2: "/userdev/complete2", //确认用户设备消息(type=3)
  userDevdeleteinfo: "/userdev/deleteinfo", //注销设备(本人的)、删除设备(其他人分享的)
  userdevLog: "/userdev/log", //用户设备日志
  userdevLogExport: "/userdev/log/export", //用户设备日志导出

  devInfo: "/dev/info", //获取设备信息
  devChangeinfo: "/dev/changeinfo", // 修改单个设备信息
  getDevLog: "/dev/log", //获取设备日志
  devLogExport: "/dev/log/export", //设备日志导出
  getDevState: "/dev/state", //获取设备历史状态
  exportDevState: "/dev/state/export", //	设备历史状态导出
  changeuse: "/dev/changeuse", //修改设备使用信息
  changeuse1: "/dev/changeuse1", //用户修改设备使用(设备坐标)
  changeDevPassword: "/dev/changeinfo2", //修改设备密码

  znwdData: "/znwd/data", //获取设备历史数据
  znwdDataExport: "/znwd/data/export", //设备历史数据导出
  znwdParamete: "/znwd/parameter", //获取设备参数
  znwdOnlineparameter: "/znwd/onlineparameter", // 实时获取设备参数(采集)
  setZnwdParamete: "/znwd/changeparameter", //修改设备参数
  powerparameter: "/znwd/powerparameter", //获取设备开关机参数
  changePowerParameter: "/znwd/changepowerparameter", //修改设备开关机参数
  getDataparameterupdown: "/znwd/dataparameterupdown", //获取设备数据上下限参数
  getOnlinePowerParameter: "/znwd/onlinepowerparameter", //获取设备数据上下限参数(采集)
  changeDataparameterupdown: "/znwd/changedataparameterupdown", //修改设备数据上下限参数
  getLastestData: "/znwd/lastestdata", //获取设备最新数据
  getOnlinelastestData: "/znwd/onlinelastestdata", //获取设备最新数据(实时)
  znwdData1: "/znwd/data1", //获取时间段内每日平均值
  znwdData2: "/znwd/data2", //获取指定日期每小时平均值
  getAlarmData: "/znwd/alarmdata", //获取指定日期后最近的十条超限值
  getAlarmData2: "/znwd/alarmdata2", //获取最近的十条超限值

  getCsInfo: "/cs/list", //获取通信服务信息

  setWdzjParamete: "/wdzj/changeparameter", //修改主机设备参数
  wdzjParamete: "/wdzj/parameter", //获取主机设备参数 
  wdzjOnlineParameter: '/wdzj/onlineparameter', // 实时获取主机设备参数(采集)

    zhwdOnlineParameter: '/zhwd/onlineparameter', // 实时获取诱导设备参数(采集)
  setZhwdParamete: "/zhwd/changeparameter", //修改诱导设备参数
  zhwdParamete: "/zhwd/parameter", //获取诱导设备参数 
};

export const config = () => {
  let func = {};

  for (let key in url) {
    func[key] = (params = {}) => {
      let data = params;
      let info = localStorage.getItem("userInfo");
      if (info) {
        data = { ...data, ...{ token: JSON.parse(info).token } };
      }
      return ajax.post(vm.$SERVER_HOST + url[key], data);
    };
  }

  return func;
};
